import { CLIENT_DOCUMENT_REQUEST_SEARCH_START_LOADING, CLIENT_DOCUMENT_REQUEST_SEARCH_END_LOADING, CLIENT_DOCUMENT_REQUEST_SEARCH_LOADED, SET_CLIENT_DOCUMENT_REQUEST_FILTER } from "../constants/ClientDocumentRequestConstants";
import { CLIENT_DOCUMENT_REQUEST_START_LOADING, CLIENT_DOCUMENT_REQUEST_END_LOADING, CLIENT_DOCUMENT_REQUEST_LOADED } from "../constants/ClientDocumentRequestConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadClientDocumentRequestSearch(filters) {
    return async (dispatch) => {
        
        await dispatch({ type: CLIENT_DOCUMENT_REQUEST_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("ClientDocumentRequest/GetPaged", filters, null);
            if(data.success) {
                await dispatch({
                    type: CLIENT_DOCUMENT_REQUEST_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: CLIENT_DOCUMENT_REQUEST_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: CLIENT_DOCUMENT_REQUEST_SEARCH_END_LOADING });
        }
    };
}


export function setClientDocumentRequestFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_CLIENT_DOCUMENT_REQUEST_FILTER,
            payload: filter
        });
    };
}

export function loadClientDocumentRequest(id, linkId, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: CLIENT_DOCUMENT_REQUEST_START_LOADING });

        try {

            var data = await getApiData("ClientDocumentRequest/GetClientDocumentRequestFBO", { id, linkId });
            if(data.success) {
                await dispatch({
                    type: CLIENT_DOCUMENT_REQUEST_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: CLIENT_DOCUMENT_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: CLIENT_DOCUMENT_REQUEST_END_LOADING });
        }
    };
}

export function saveClientDocumentRequest(fbo, status, message, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: CLIENT_DOCUMENT_REQUEST_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("ClientDocumentRequest/SaveClientDocumentRequestFBO", { status, message }, fbo);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/client-document-request-edit/' + data.responseEntities[0].clientDocumentRequest.id);
                    dispatch(commonActions.setSuccessMessage("Client Document Ticket Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: CLIENT_DOCUMENT_REQUEST_LOADED,
                        payload: data.responseEntities[0]
                    });

                    if(status === "Submitted") {
                        dispatch(commonActions.setSuccessMessage("Client Document Ticket Submitted to client Successfully!"));
                    }
                    else if(status === "Client Responded") {
                        dispatch(commonActions.setSuccessMessage("Information Submitted Successfully!"));
                    }
                    else {
                        dispatch(commonActions.setSuccessMessage("Client Document Ticket Saved Successfully!"));
                    }
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: CLIENT_DOCUMENT_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: CLIENT_DOCUMENT_REQUEST_END_LOADING });
        }
    };
}